import { actionConst } from '../constants/address.constants';

const defaultState = {
	addressModalVisible: false,
	possWarrantyModalVisible: false,
	setAddressRequestID: undefined,	
	record: {},
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case actionConst.SHOW_ADDRESS_OK: {
			return {
				...state,
				setServiceRequestID: action.payload,
			}
		}
		case actionConst.HIDE_ADDRESS_OK: {
			return {
				...state,
				setServiceRequestID: undefined
			}
		}
		case actionConst.OPEN_ADDRESS_MODAL: {
			return {
				...state,
				record: action.payload,
				addressModalVisible: true,
			}
		}
		case actionConst.OPEN_POSS_WARRANTY_MODAL: {
			return {
				...state,
				record: action.payload,
				possWarrantyModalVisible: true,
			}
		}
		case actionConst.CLOSE_ADDRESS_MODAL: {
			return {
				...state,
				addressModalVisible: false
			}
		}
		case actionConst.CLOSE_POSS_WARRANTY_MODAL: {
			return {
				...state,
				possWarrantyModalVisible: false
			}
		}
		default:
			return state;
	}
}